import type { ImageBlock as ImageBlockType } from "@/types";

export function ImageBlock({ block }: { block: ImageBlockType }) {
  const { asset_url, alt, caption, layout = "full" } = block.props;
  if (!asset_url) return null;
  return (
    <figure className={`block block--image block--image--${layout}`}>
      <img src={asset_url} alt={alt ?? ""} loading="lazy" />
      {caption ? <figcaption className="block--image__caption">{caption}</figcaption> : null}
    </figure>
  );
}
